import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TypeForm } from '../../components/AuthDialog/auth.interface';

import { checkAuth, getProfile, login, logout, register } from './user.actions';
import { IInitialState, IUserType } from './user.interface';
import { IUserProfile } from './user.interface';

//Пользователь, его данные о входе в систему
const initialState: IInitialState & IUserType = {
  user: {
    email: "",
    error: false,
    error_code: 0,
    message: "",
    phone: "",
    super_admin: false,
    user_has_permanent_password: false,
    valid: false
  },
  isLoading: false,
  formType: 'phone',
  authModal: false,
  enable: false,
  session_token: '',
  phone_or_email: '',
  visibleAuthDialog: false,
  visibleDrawerDialog: false,
  visibleMenuDialog: false,
  visibleOrganization: false,
  openCategory: 'processes',
  openMobileCategory: 'processes',
  loading: false,
  loggedIn: false,
  super_admin: false,
  isOffline: false,
  profile: null,
  likePending: false,
};
export const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: any) => {
      state.user = action.payload;
    },
    setSessionToken: (state, action: any) => {
      state.session_token = action.payload;
    },
    setPhoneOrEmail: (state, action: any) => {
      state.phone_or_email = action.payload;
    },
    setAuthVisible: (state, action) => {
      state.visibleAuthDialog = action.payload;
    },
    setMenuVisible: (state, action) => {
      state.visibleMenuDialog = action.payload;
    },
    setVisibleOrganization: (state, action) => {
      state.visibleOrganization = action.payload;
    },
    setVisibleDrawerDialog: (state, action) => {
      state.visibleDrawerDialog = action.payload;
    },
    setOpenCategory: (state, action: PayloadAction<string>) => {
      state.openCategory = action.payload;
    },
    setOpenMobileCategory: (state, action: PayloadAction<string>) => {
      state.openMobileCategory = action.payload;
    },
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    setSuperAdmin: (state, action: PayloadAction<boolean>) => {
      state.super_admin = action.payload;
    },
    setIsOffline: (state, action: PayloadAction<boolean>) => {
      state.isOffline = action.payload;
    },
    setFormType: (state, action: PayloadAction<TypeForm>) => {
      state.formType = action.payload;
    },
    setAuthModal: (state, action: PayloadAction<boolean>) => {
      state.authModal = action.payload;
    },
    setLikePending(state, action: PayloadAction<boolean>) {
      state.likePending = action.payload;
    },
    setProfile(state, action: PayloadAction<IUserProfile | null>){
      state.profile = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => {
        state.isLoading = true;
        state.likePending = true;
      })
      .addCase(register.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.formType = 'code';
        state.likePending = false;
      })
      .addCase(register.rejected, (state) => {
        state.isLoading = false;
        state.user = null;
        state.likePending = false;
      })
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.likePending = true;
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        
        //loggedIn и user заполняются в login createAsyncThunk
        //state.loggedIn = true;
        //state.user = payload;
        
        state.visibleAuthDialog = false;
        state.formType = 'phone';
        state.likePending = false;
      })
      .addCase(login.rejected, (state) => {
        state.isLoading = false;
        state.user = null;
        state.loggedIn = false;
        state.likePending = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isLoading = false;
        state.user = null;
        state.profile = null;
        state.loggedIn = false;
        state.formType = 'phone';
      })
      .addCase(checkAuth.pending, (state, { payload }) => {
        state.likePending = true;
      })
      .addCase(checkAuth.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.likePending = false;
      })
      .addCase(checkAuth.rejected, (state) => {
        state.isLoading = false;
        state.user = null;
        state.loggedIn = false;
        state.likePending = false;
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.profile = payload;
      });
    /*      .addCase(checkAuth.fulfilled, (state, { payload }) => {
        state.user = payload.user;
      });*/
  },
});
export const userActions = userSlice.actions;
export const { reducer } = userSlice;
